//默认导入
const { ccclass, property } = cc._decorator;
import ModuleBase, { ViewLayer, moduleInit } from "../../../../framework/core/mvvm/module_base";

import DialogView from "./dialog_view";
import Utility from "../../../../utility/utility";

@ccclass
@moduleInit("Dialog")
export default class Dialog extends ModuleBase<DialogView, null> {

    scheduleCallback: Function
    private maxNumb:number = 666
    constructor() {
        super();
        this.package = "public";
        this.layer = ViewLayer.Highest;
        this.windowPrefabResPath = "package/public/public_dialog";
        this.viewType = DialogView;
        this.needViewMask = true
        this.clickAnywhereClose = false
    }

    _leftBtnCallback: Function
    _rightBtnCallback: Function
    _centerBtnCallback: Function

    _clickLeftBtnNotHideView: any
    _clickRightBtnNotHideView: any
    _clickCenterBtnNotHideView: any

    onInit(arg) {
        super.onInit(arg)
        let self = this
        this.view.button_left.node.on('click', function (event) {
            Utility.playButtonSound()
            if (!self._clickLeftBtnNotHideView) {
                self.hide()
            }
            if (self._leftBtnCallback) {
                self._leftBtnCallback()
            }
        })
        this.view.button_right.node.on('click', function (event) {
            Utility.playButtonSound()
            if (!self._clickRightBtnNotHideView) {
                self.hide()
            }
            if (self._rightBtnCallback) {
                self._rightBtnCallback()
            }
        })
        this.view.button_center.node.on('click', function (event) {
            Utility.playButtonSound()
            if (!self._clickCenterBtnNotHideView) {
                self.hide()
            }
            if (self._centerBtnCallback) {
                self._centerBtnCallback()
            }
        })
    }

    show_center_button(title: string, text: string, callback?: Function, clickButtonConfirmNotHideView?) {
        callback = callback || function () { }
        this.show_custom_dialog(title, text, null, null, callback, null, null, clickButtonConfirmNotHideView)
    }

    //默认显示两个按钮，左边为取消，右边为确定
    show_common(title: string, text: string, confirmCallback?: Function, cancelCallback?: Function, clickButtonConfirmNotHideView?) {
        confirmCallback = confirmCallback || function () { }
        cancelCallback = cancelCallback || function () { }
        this.show_custom_dialog(title, text, cancelCallback, confirmCallback, null, null, clickButtonConfirmNotHideView)
    }

    show_custom_dialog(title: string, text: string, leftBtnCallback: Function, rightBtnCallback: Function, centerBtnCallback: Function, clickLeftBtnNotHideView?, clickRightBtnNotHideView?, clickCenterBtnNotHideView?) {
        if (!this.view) {
            let data = {
                title: title,
                text: text,
                leftBtnCallback: leftBtnCallback,
                rightBtnCallback: rightBtnCallback,
                centerBtnCallback: centerBtnCallback,
                clickLeftBtnNotHideView: clickLeftBtnNotHideView,
                clickRightBtnNotHideView: clickRightBtnNotHideView,
                clickCenterBtnNotHideView: clickCenterBtnNotHideView,
            }
            this.AddHandleToWaitDealQueue(this.show_custom, data, this)
            return
        }
        if (!title) {
            this.view.label_title.node.active = false
            title = ''
        } else {
            this.view.label_title.node.active = true
        }
        if (!text) {
            text = ''
        }
        this.view.label_title.string = title
        this.view.label_content.string = text
        if (!leftBtnCallback) {
            this.view.button_left.node.active = false
            this._leftBtnCallback = null
            this._clickLeftBtnNotHideView = null
        } else {
            this.view.button_left.node.active = true
            this._leftBtnCallback = leftBtnCallback
            this._clickLeftBtnNotHideView = clickLeftBtnNotHideView
        }

        if (!rightBtnCallback) {
            this.view.button_right.node.active = false
            this._rightBtnCallback = null
            this._clickRightBtnNotHideView = null
        } else {
            this.view.button_right.node.active = true
            this._rightBtnCallback = rightBtnCallback
            this._clickRightBtnNotHideView = clickRightBtnNotHideView
        }

        if (!centerBtnCallback) {
            this.view.button_center.node.active = false
            this._centerBtnCallback = null
            this._clickCenterBtnNotHideView = null
        } else {
            this.view.button_center.node.active = true
            this._centerBtnCallback = centerBtnCallback
            this._clickCenterBtnNotHideView = clickCenterBtnNotHideView
        }
        this.updateLabLayout();
        this.view.label_title.node.active = false;//取消标题ps 美术
        this.view.show()
    }

    show_custom(data) {
        this.show_custom_dialog(data.title, data.text, data.leftBtnCallback, data.rightBtnCallback, data.centerBtnCallback, data.clickLeftBtnNotHideView, data.clickRightBtnNotHideView, data.clickCenterBtnNotHideView)
    }

    private updateLabLayout(){
        this.view.label_content.overflow = cc.Label.Overflow.NONE;
        this.view.label_content.horizontalAlign = cc.Label.HorizontalAlign.CENTER;
        //@ts-ignore
        this.view.label_content._forceUpdateRenderData(true);
        if (this.view.label_content.node.width >this.maxNumb) {
            this.view.label_content.node.width = this.maxNumb;
            this.view.label_content.overflow = cc.Label.Overflow.RESIZE_HEIGHT;
            this.view.label_content.horizontalAlign = cc.Label.HorizontalAlign.LEFT;
        }
    }
}